module.exports = fox._r("fonts/robotocondensed-italic-webfont.ttf", __webpack_public_path__ + "_/_/_/root/fonts/knK-emu.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-italic-webfont.ttf
// module id = 181
// module chunks = 4